export default {
  userProfiles(state) {
    return state.userProfiles;
  },
  currentUser(state) {
    // console.log("currentUser(): currentUser = ", state.currentUser);
    return state.currentUser;
  },
  userName(state) {
    return state.currentUser.userName;
  },
  email(state) {
    return state.currentUser.email;
  },
  isAdmin(state) {
    return state.currentUser.isAdmin;
  },
}